<template>
  <div class="flex_center bottom_title">Data Provided by Refinitiv</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.bottom_title {
  font-size: 12px;
  text-align: center;
  color: #707070;
}
</style>
